import React, { useEffect, useState, memo } from "react";
import Layout from "../../components/layout/Layout";
import axios from "axios";
import Loader from "../../components/Loader";
import { GrEdit } from "react-icons/gr";
import { FaFileCirclePlus } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Modal, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import EditCustomerDialog from "../../components/EditCustomerDialog";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import countries from "countries-list";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { mobileScroll, normalizeValues } from "common/FunctionUtils";
import { LOCALES } from "common/constants";
import { useNavigate } from "react-router-dom"; 

const Customers = () => {
  let language = localStorage.getItem("i18nextLng");
  const { t } = useTranslation();
  const [customers, setCustomers] = useState([]);
  const [deleteCustomer, setDeleteCustomer] = useState(null);
  const [editCustomer, setEditCustomer] = useState(null);
  const [addCustomer, setAddCustomer] = useState(false);
  const [loading, setLoading] = useState(false);

  const globalData = useSelector((state) => state.globalData.data);
  const location = useLocation();

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/customer");
      setCustomers(res.data.response);
    } catch (err) {
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  const onDeleteCustomer = async () => {
    try {
      setLoading(true);
      await axios.delete(`/customer/${deleteCustomer.customerId}`);
      setDeleteCustomer(null);
      fetchCustomers();
      toast.success(t("Customer deleted successfully"));
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setLoading(false);
    }
  };

  const onEditCustomer = async (values) => {
    if (
      values?.accountType != "1" &&
      (values?.isVATRegistred === "true" || values?.isVATRegistred === true) &&
      !values?.vatNumber
    ) {
      return toast.error(t("Please enter your VAT number"));
    }

    let countryCode = "";
    Object.keys(countries.countries).forEach((code) => {
      if (countries.countries[code].name === values.country) {
        countryCode = code;
      }
      if (values.country === "USA") {
        countryCode = "US";
      }
    });
    try {
      setLoading(true);
      let concatVatNumber;
      if (values?.accountType == "1") {
        values.vatNumber = "";
      } else if (
        values?.isVATRegistred === "false" ||
        values?.isVATRegistred === false
      ) {
        values.vatNumber = "";
      } else if (
        values?.isVATRegistred === "true" ||
        values?.isVATRegistred === true
      ) {
        concatVatNumber = countryCode + values.vatNumber;
        values.vatNumber = concatVatNumber;
      }

      // normalizing values
      const orgNo =
        values?.accountType != "1" && values?.orgNo
          ? normalizeValues(values, "orgNo")
          : "";
      const ssn =
        values?.accountType == "1" && values?.ssn
          ? normalizeValues(values, "ssn")
          : "";

      await axios.put("/customer", {
        ...values,
        id: editCustomer.customerId,
        countryCode,
        orgNo,
        ssn,
      });
      setEditCustomer(null);
      fetchCustomers();
      toast.success(t("Customer updated successfully"));
      setLoading(false);
    } catch (err) {
      toast.error(t(err?.response?.data?.message));
      setLoading(false);
    }
  };

  const addNewCustomer = async (values) => {
    if (
      values?.accountType != "1" &&
      (values?.isVATRegistred === "true" || values?.isVATRegistred === true) &&
      !values?.vatNumber
    ) {
      return toast.error(t("Please enter your VAT number"));
    }

    let countryCode = "";
    Object.keys(countries.countries).forEach((code) => {
      if (countries.countries[code].name === values.country) {
        countryCode = code;
      }
      if (values.country === "USA") {
        countryCode = "US";
      }
    });
    try {
      setLoading(true);
      let concatVatNumber;
      if (values?.accountType == "1") {
        values.vatNumber = "";
      } else if (
        values?.isVATRegistred === "false" ||
        values?.isVATRegistred === false
      ) {
        values.vatNumber = "";
      } else if (
        values?.isVATRegistred === "true" ||
        values?.isVATRegistred === true
      ) {
        concatVatNumber = countryCode + values.vatNumber;
        values.vatNumber = concatVatNumber;
      }

      // normalizing values
      const orgNo =
        values?.accountType != "1" && values?.orgNo
          ? normalizeValues(values, "orgNo")
          : "";
      const ssn =
        values?.accountType == "1" && values?.ssn
          ? normalizeValues(values, "ssn")
          : "";

      const res = await axios.post("/customer", {
        ...values,
        countryCode,
        orgNo,
        ssn,
      });
      if (res.data.response) {
        setAddCustomer(false);
        fetchCustomers();
        toast.success(t("Added new customer successfully"));
      } else {
        throw new Error(res.data.message);
      }
    } catch (err) {
      // setCustomers([]);
      setLoading(false);
      if (err?.response) {
        toast.error(t(err?.response?.data?.message));
      } else {
        toast.error(t(err?.message));
      }
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 my-customers-table margin-top-60"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/customers"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/kunder"
          />
        )}
      </Helmet>
      {loading && <Loader />}

      <div className="customerDetailsHeading  align-items-center mb-3 new_cus">
        <div>
          <h4 className="accident_ins font-weight-bold">{t("My customers")}</h4>
          <p className="mb-0">
            {t(
              "Here you can delete or change existing customers. You enter new customers in the invoice tool."
            )}
          </p>
        </div>

        <div>
          <Button
                  variant="primary"
                  className="mb-2"
                  onClick={() => navigate(`/dashboard/invoice-tool?lang=${LOCALES.EN_US}`)} // Added navigation
                >
                  {t("Create Invoice")}
                </Button>

        <Button
          variant="outline-primary"
          className="mb-2 ml-2"
          onClick={() => setAddCustomer(true)}
        >
          {t("Add new Customer")}
        </Button>
        </div>
      </div>

      <div className="table-div">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">Id</th>
              <th className="invoice_tabeletext">{t("Customer")}</th>
              <th className="invoice_tabeletext">{t("Org No")}</th>
              <th className="invoice_tabeletext">{t("Reference")}</th>
              <th className="invoice_tabeletext">{t("Address")}</th>
              <th className="invoice_tabeletext text-center">{t("Change")}</th>
              <th className="invoice_tabeletext text-center">{t("Create Invoice")}</th>
              <th className="invoice_tabeletext text-center">{t("Remove")}</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((data) => {
              return (
                <tr key={data?.customerId}>
                  <td>{data?.customerId}</td>
                  <td>{data?.name}</td>
                  <td>{data?.orgNo}</td>
                  <td>{data?.reference}</td>
                  <td>{data?.address}</td>
                  <td>
                    <div className="color-bg">
                      <GrEdit
                        className="cursor-pointer"
                        onClick={() => setEditCustomer(data)}
                        size={24}
                        id="top"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("Edit")}
                      />
                    </div>
                  </td>
                  <td>
                  <div className="color-bg">
                    <FaFileCirclePlus 
                     className="cursor-pointer"
                     size={24}
                     id="top"
                     data-toggle="tooltip"
                     data-placement="top"
                     title={t("Create Invoice")}
                     onClick={() => navigate(`/dashboard/invoice-tool?lang=${LOCALES.EN_US}&customerId=${data?.customerId}`)} // Added onClick handler
                    />
                    </div>
                  </td>
                  <td>
                    <div className="color-bg">
                      <RiDeleteBin6Line
                        className="cursor-pointer"
                        onClick={() => setDeleteCustomer(data)}
                        size={24}
                        id="top"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("Delete")}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      {deleteCustomer && (
        <Modal show={true} onHide={() => setDeleteCustomer(null)}>
          <Modal.Header>
            <Modal.Title>{t("Delete Customer")}</Modal.Title>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() => setDeleteCustomer(null)}
            />
          </Modal.Header>
          <Modal.Body>
            {t("Are you sure you want to remove")} <b>{deleteCustomer?.name}</b>{" "}
            ?
          </Modal.Body>
          <Modal.Footer>
            <button
              className="outline_btn_new"
              variant="secondary"
              onClick={() => setDeleteCustomer(null)}
            >
              {t("Cancel")}
            </button>
            <Button
              className="text-light delete_customer new_theme_btn "
              variant="primary"
              onClick={onDeleteCustomer}
            >
              {t("Delete")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {editCustomer && (
        <EditCustomerDialog
          title={t("Edit Customer")}
          show={true}
          onClose={() => setEditCustomer(null)}
          onSubmit={onEditCustomer}
          customer={{
            co: editCustomer.co,
            name: editCustomer.name,
            city: editCustomer.city,
            orgNo: editCustomer.orgNo,
            email: editCustomer.email,
            isVATRegistred: editCustomer.isVATRegistred,
            zipCode: editCustomer.zipCode,
            country: editCustomer.country,
            address: editCustomer.address,
            address2: editCustomer.address2,
            reference: editCustomer.reference,
            language: editCustomer?.language,
            phoneNumber: editCustomer.phoneNumber,
            paymentTerm: editCustomer.paymentTerm,
            secondaryEmailAddress: editCustomer.secondaryEmailAddress,
            ssn: editCustomer.ssn,
            accountType: editCustomer.accountType,
            vatNumber: editCustomer.vatNumber,
            invoiceType: editCustomer.customerAddress[0].invoiceType,
            yourElectronicReference: editCustomer.customerAddress[0].yourElectronicReference,
            globalLocationNumber: editCustomer.customerAddress[0].globalLocationNumber,
            extraField1: editCustomer.customerAddress[0].extraField1,
            extraField2: editCustomer.customerAddress[0].extraField2,
          }}
          paymentTerms={globalData.paymentTerms}
          getLocation={location}
        />
      )}
      {addCustomer && (
        <EditCustomerDialog
          title={t("Add new Customer")}
          show={true}
          onClose={() => setAddCustomer(false)}
          onSubmit={addNewCustomer}
          paymentTerms={globalData.paymentTerms}
          getLocation={location}
        />
      )}
    </Layout>
  );
};

export default memo(Customers);